import { useEffect } from "react"
import { setLs } from "../utils/localStorage"

const getParams = (params: string[]) => {
  let res: any = {}
  if (typeof window === `undefined`) {
    return res
  }
  let search = window.location.search
  if (search && search.includes("%")) {
    let altSearch = ""
    try {
      altSearch = decodeURIComponent(search)
      altSearch = decodeURIComponent(altSearch)
    } catch (e) {}
    search = altSearch ?? search
  }
  if (search.startsWith("??")) {
    search = search.slice(1)
  }
  const searchParams = new URLSearchParams(search)
  params.forEach(p => {
    if (searchParams.has(p)) {
      res[p] = searchParams.get(p)
    }
  })
  return res
}

const initQueryParams = () => {
  const {
    sc,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
    utm_id,
    fbclid,
    cid,
  } = getParams([
    "sc",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_id",
    "fbclid",
    "cid",
  ])

  if (cid) {
    let expiry = new Date()

    expiry.setDate(expiry.getDate() + 10)

    setLs("coupon", {
      id: cid,
      expiry: expiry.toISOString(),
    })
  }

  useEffect(() => {
    if (
      utm_source ||
      utm_medium ||
      utm_campaign ||
      utm_term ||
      utm_content ||
      utm_id
    ) {
      const date = new Date()
      setLs("utm", {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content,
        utm_id,
        created: new Date(date.setDate(date.getDate())),
      })
    }

    if (fbclid) {
      const fbc = fbclid.includes("?fbclid=")
        ? fbclid.split("?fbclid=")[0]
        : fbclid
      const date = new Date()
      setLs("fbc", {
        value: "fb.1." + +new Date() + "." + fbc,
        expiry: new Date(date.setDate(date.getDate() + 60)), //expire in 60 days
      })
    }
  }, [])
}

export default initQueryParams
